import {combineReducers} from 'redux'
// import thunk from "redux-thunk";
import {configureStore} from '@reduxjs/toolkit'
import {reservationsReducer} from "./reservations.reducer";
import {actionReducer} from "./action.reducer";
import {authReducer} from 'crqlar-react-common/dist/state/auth.reducer';

// declare global {
//     interface Window {
//         __REDUX_DEVTOOLS_EXTENSION_COMPOSE__?: typeof compose;
//     }
// }

// const middlewares = [thunk];

// const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export const store = configureStore(
    {
        reducer: combineReducers({
            reservations: reservationsReducer,
            auth: authReducer,
            // actionReducer: Click button actions & more
            action: actionReducer,

        }),
        middleware: (getDefaultMiddleware) => getDefaultMiddleware({
            serializableCheck: false
        })
    }
)
